<script setup>
    import { useI18n } from 'vue-i18n';
    import { computed, onMounted } from 'vue';
    import forEach from "lodash/forEach";

    const { t } = useI18n();

    const props = defineProps({
        modalShop: {
            type: Object,
            default: null,
        },

        shopTitleLevelClass: {
            type: String,
            default: null,
        },

        productType: {
            type: String,
            default: null,
        },

    });

    const currentName = computed(() => {
        let name = "";
        if(props.modalShop !== null && props.modalShop.name !== null) {
            name = props.modalShop.name;
        }
        return name;
    });

    onMounted(() => {
        forEach(document.getElementsByClassName("shop-link"), $link => {
            $link.addEventListener('click',() => {
                if (window.dataLayer){
                    let shopName = JSON.stringify(props.modalShop.name);
                    let productName = JSON.stringify(props.productType);

                    window.dataLayer.push({
                        event: "clickedDistributorLink",
                        "shop-name": shopName,
                        "product-name": productName,
                    });
                }
                return true;
            });
        });

    });

</script>

<template>
    <div class="shop">
        <div class="text">
            <span class="shop-name title " :class="shopTitleLevelClass">
                {{ currentName }}
            </span>
        </div>
        <a :href="modalShop.url" target="_blank" class="shop-link button is-primary" rel="nofollow">
            <svg class="icon icon-cart" aria-hidden="true">
                <use xlink:href="#icon-cart" />
            </svg>
            {{ t('productDetails.Ordering.Codes.BuyNow') }}
        </a>
    </div>
</template>

<style lang="scss">
    @import '../../../../scss/variables';
    @import '../../../../scss/utilities/all';
    @import '../../../../scss/forms/_all.scss';

</style>
